import React from 'react';
import "./index.css";

const MenusAffichage = (props) => {
    const list = props.data;

    return (
        <>{
            list.map((menu) => {
                if (menu.type) {
                    return (
                        <div key={menu.id} id={menu.id} className="menus-content">
                            <h1>{menu.title} {["menu_midi_14"].includes(menu.id) ? "\n\nEntrée + Plat OU Plat + Déssert": null}</h1>
                            <div className="menus__inside">
                            <ul className="ul_carte">
                                <div className="type">
                                    {
                                        menu.type.map((item, index) => {
                                            return (
                                                <div key={index}>
                                                    <h2>{item.title}</h2>
                                                    <h3>Entrées</h3>
                                                    {
                                                        item.entrees.map((i) => {
                                                            return <li key={i}>{i}</li>
                                                        })
                                                    }

                                                    <h3>Plats</h3>
                                                    {
                                                        item.plats.map((i) => {
                                                            return <li key={i}>{i}</li>
                                                        })
                                                    }
                                                </div>
                                            )
                                        })
                                    }
                                </div>

                                <h3>Desserts</h3>
                                {
                                    menu.desserts.map((i) => {
                                        return <li key={i}>{i}</li>
                                    })
                                }
                            </ul>
                            </div>
                        </div>
                    )
                } else {
                    return (
                        <div key={menu.id} id={menu.id} className="menus-content">
                            <h1>{menu.title} {["menu_degustation_25"].includes(menu.id) ? "(Entrée + Plat OU Plat+Dessert) + Boisson": "Entrée + Plat OU Plat + Déssert"}</h1>

                            <div className="menus__inside">
                            <ul className="ul_carte">
                                <h3>Entrées</h3>
                                {
                                    menu.entrees.map((i) => {
                                        return <li key={i}>{i}</li>
                                    })
                                }

                                <h3>Plats</h3>
                                {
                                    menu.plats.map((i) => {
                                        return <li key={i}>{i}</li>
                                    })
                                }

                                {menu.accompagnement ?
                                    <>
                                        <h3>Accompagnements</h3>
                                        {
                                            menu.accompagnement.map((i) => {
                                                return <li key={i}>{i}</li>
                                            })
                                        }
                                    </> : null}

                                {menu.boisson ?
                                    <>
                                        <h3>Boissons</h3>
                                        {
                                            menu.boissons.map((i) => {
                                                return <li key={i}>{i}</li>
                                            })
                                        }
                                    </> : null}

                                <h3>Desserts</h3>
                                {
                                    menu.desserts.map((i) => {
                                        return <li key={i}>{i}</li>
                                    })
                                }
                            </ul>
                            </div>
                        </div>
                    )
                }

            })
        }
        </>
    );

};

export default MenusAffichage;